import Core from '../plugin-core-system/core.class.js';

export default class CsCookieBannerHandler extends Core {

  static customFunctions = {
    showMap: () => {
      // eslint-disable-next-line
      if (typeof google === 'undefined' || typeof google.maps === 'undefined') {

        const link = document.querySelector('.js-gme-container');
        const script = document.createElement('script');
        if(link) {
          script.src = link.dataset.library;
          document.body.appendChild(script);
        }
      }
    }
  };

  /**
   * main init function
   */
  init() {
    // needs to be there, even if there is no function content
  }
}
